var _excluded = ["className"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';
import classNames from 'classnames';
import { menuGetTree } from '../../../redux/actions/Entity/Menu';
import { normalizeLink, isExternalLink } from '../../../helpers/link';
import ContextualActionsButtons from "../../../Components/ContextualActions/Buttons";
var Menu = /*#__PURE__*/function (_Component) {
  _inherits(Menu, _Component);
  var _super = _createSuper(Menu);
  function Menu() {
    var _this;
    _classCallCheck(this, Menu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "sortMenu", function (menu) {
      var sortedMenu = menu.sort(function (itemA, itemB) {
        var weightA = parseInt(itemA.getIn(['link', 'weight']));
        var weightB = parseInt(itemB.getIn(['link', 'weight']));
        return weightA - weightB;
      });
      return sortedMenu;
    });
    return _this;
  }
  _createClass(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        menu = _this$props.menu,
        id = _this$props.id,
        dispatch = _this$props.dispatch;
      if (id && !menu) {
        dispatch(menuGetTree(id));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        currentLanguage = _this$props2.currentLanguage,
        id = _this$props2.id,
        dispatch = _this$props2.dispatch;
      if (prevProps.currentLanguage !== currentLanguage) {
        dispatch(menuGetTree(id));
      }
    }
  }, {
    key: "renderMenuItems",
    value: function renderMenuItems(menu) {
      var menuItemProps = this.props.menuItemProps;
      // TODO: set menu active state from here instead of navigation
      if (!menu) return null;
      return menu.map(function (item, index) {
        var attrs = item.getIn(['link', 'options', 'attributes'], Map());
        var href = normalizeLink(item.getIn(['link', 'url']));
        var title = item.getIn(['link', 'title'], 'Untitled');
        var className = menuItemProps.className,
          menuItemPropsLocal = _objectWithoutProperties(menuItemProps, _excluded);
        var otherAttrs = _objectSpread({
          className: classNames(className),
          target: attrs.get('target')
        }, menuItemPropsLocal);
        return /*#__PURE__*/React.createElement("li", {
          key: "menu--".concat(item.getIn(['link', 'menu_name']), "--menu-item-").concat(title, ":").concat(href)
        }, isExternalLink(href) ? /*#__PURE__*/React.createElement("a", _extends({
          href: href
        }, otherAttrs), title) : /*#__PURE__*/React.createElement(Link, _extends({
          to: href
        }, otherAttrs), title));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        id = _this$props3.id,
        menu = _this$props3.menu,
        children = _this$props3.children;
      // @FIXME this check doesn't work, error object is in state
      if (!menu) {
        return null;
      }
      var sortedMenu = this.sortMenu(menu);
      var classes = classNames('Menu', "menu--".concat(id));
      return /*#__PURE__*/React.createElement(ContextualActionsButtons, {
        entityType: "menu",
        entity: {
          id: id
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes
      }, typeof children === 'function' ? children(sortedMenu) : /*#__PURE__*/React.createElement("ul", null, this.renderMenuItems(sortedMenu))));
    }
  }]);
  return Menu;
}(Component);
Menu.propTypes = {
  id: PropTypes.string.isRequired,
  menuItemProps: PropTypes.shape({
    className: PropTypes.string
  })
};
Menu.defaultProps = {
  menuItemProps: {}
};
function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    children: ownProps.children,
    menu: state.getIn(['menu', ownProps.id]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}
export default connect(mapStateToProps)(Menu);